module.exports = __webpack_public_path__ + "img/thumbnail_MenelausBlueMorpho_u_normal.7fd76c1f.png";